<template>
  <div :id="summaryID" v-bind="attrs">
    <div class="text-body2 q-pa-sm">{{ title }}</div>
    <ul class="text-caption">
      <li v-for="cell in data['GRID']">
        <span >{{ cell }}</span>
      </li>
    </ul>
  </div>
</template>
<script setup>
import { toRefs, computed, useAttrs, onMounted } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"

const attrs = useAttrs();

const {  ecos, loadDataByID,activeLayerID } = useMapItems()
const {  } = useHelpers();

const props = defineProps({
    data: { type: Object },
    ecoregion: {type: String},
    version:  {type: Number}
})

const { data, ecoregion, version } = toRefs(props)

const summaryID = computed(() =>{
  return 'ecoregionSummary_' + ecoregion.value;
})

const title = computed(() => {
    let text =  ecos[ecoregion.value] + " Ecoregion"
    return text
})

onMounted(() =>{
  if (activeLayerID.value != "GRID"){
    loadDataByID('GRID', version)
  }
})
</script>
<style scoped>
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;
 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
</style>